<template>
    <span>
        <font-awesome-layers fixed-width>
            <font-awesome-icon icon="file-contract" />
            <font-awesome-icon
                class="text-white"
                icon="circle"
                transform="shrink-6 down-6 right-4" />
            <font-awesome-icon
                class="secondary-icon"
                icon="info-circle"
                transform="shrink-5 down-6 right-4" />
        </font-awesome-layers>
        <span>
            {{ changeWordingRegistrationBuy ? $t('menu.details') : $t('menu.registrationDetails') }}
        </span>
    </span>
</template>
<script>
import registrationOnlineRegistrationFieldsMixin
    from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";

export default {
    name: 'MenuItemRegistrationDetails',
    mixins: [registrationOnlineRegistrationFieldsMixin],
}
</script>
<style lang="scss" scoped>

</style>